



































import Vue from 'vue'
import { mapGetters } from 'vuex'

/* eslint-disable */ 
import { Trim } from '../models/Trim'
/* eslint-enable */ 

export default Vue.extend({
  props: ['column'],
  computed: {
    ...mapGetters({
      currentDealer: 'dealers/currentDealer',
      currentModel: 'models/currentModel',
      loading: 'trims/loading',
      modelId: 'models/currentModelId',
      trims: 'trims/trims'
    }),
    cols () : number {
      if (this.column === true) {
        return 6
      } else {
        const { xs, sm } = this.$vuetify.breakpoint
        return xs || sm ? 6 : 4
      }
    },
  },
  methods: {
    async trimSelected(trim: Trim) {
      this.$emit('trimSelected')
      this.$store.dispatch('trims/setCurrentTrim', trim)
      this.$store.dispatch('terms/getTerms', { trim: trim, modelId: this.modelId, manufacturer: this.currentDealer.manufacturerId })
      this.$router.push({ path: '/' + this.$route.params.makeId + '/' + this.$route.params.dealerCode + '/products' })
    }
  }
})
